import FeaturesContainer from './FeaturesContainer';
import useImagesSrc from '../../helper/useImagesSrc';

const Location = ({ history, onePage }) => (
  <FeaturesContainer
    history={history}
    onePage={onePage}
    title={'real_time_location'}
    adaptiveHeight={850}
    eventName={'onboardingCheckLocation'}
    nextPage={'/place-alerts'}
    imagePreload={useImagesSrc().imagesSources.placeAlerts}
    imageName={'Location'}
    imageAlt={'Real time-location'}
  />
);

export default Location
